import type { BottomTabItem } from '@cubemeet/ui';

// Centralized bottom navigation items used by web pages.
// Edit here to change icons/labels across the web app in one place.
export const bottomItems: BottomTabItem[] = [
  // 使用中文标签，保持统一的用户体验
  { key: 'home', label: '首页', icon: 'home', labelKey: 'navigation.home' },
  { key: 'notifications', label: '通知', icon: 'notifications', labelKey: 'navigation.notifications' },
  { key: 'hub', label: '', icon: 'apps' }, // 中心按钮，无标签
  { key: 'profile', label: '我的', icon: 'person', labelKey: 'navigation.profile' },
  { key: 'settings', label: '设置', icon: 'settings', labelKey: 'navigation.settings' },
];

// Route mapping for a given tab key. If you need different behavior for
// authenticated vs unauthenticated flows you can extend this function.
export const getRouteForKey = (key: string) => {
  const map: Record<string, string> = {
    home: '/',
    settings: '/settings',
    notifications: '/notifications',
    hub: '/travel',
    profile: '/profile',
    friends: '/friends',
  };
  return map[key] || '/';
};

export default { bottomItems, getRouteForKey };
